import { createBasicLocation } from "src/router/routeTypes"

const Inbox = createBasicLocation("/inbox")

export const InboxRoutes = {
  Inbox,
} as const
